import { Platform } from 'react-native';
export const webFont = (font) => Platform.select({
    web: `${font}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`,
    default: font,
});
//# sourceMappingURL=webFont.js.map